// import { useHealthblocksTranslations } from '@bothrs/translations'
import { useLocal, useProjectFallback } from '@healthblocks-io/core'

import { useSyncSessionCredentials } from '@/modules/auth/hooks/useSyncSessionCredentials'
import { HealthblocksMemberProvider } from '../healthblocks-member-providers/HealthblocksMemberProvider'

import type { ReactElement, ReactNode } from 'react'

type Props = { children: ReactNode }

const HealthblocksAppProvider = ({ children }: Props) => {
  const fallback = useProjectFallback()
  const localState = useLocal()

  // Here rather than on a route, so every refresh reaches the keychain, also
  // while the lock screen or a route outside Authenticated is showing
  useSyncSessionCredentials()

  if (!localState || fallback) {
    return <>{children}</>
  }

  return <HealthblocksMemberProvider>{children as unknown as ReactElement}</HealthblocksMemberProvider>
}

export { HealthblocksAppProvider }
